import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getProjectNotes,
  getProjectNote,
  createProjectNote,
  updateProjectNote,
  toggleProjectNotePin,
  deleteProjectNote,
  GetProjectNotesParams,
  CreateProjectNoteDto,
  UpdateProjectNoteDto,
} from "./project-notes.services";

export const useGetProjectNotes = (params?: GetProjectNotesParams) => {
  return useQuery({
    queryKey: ["project-notes", params],
    queryFn: () => getProjectNotes(params),
    enabled: !!params?.projectId,
  });
};

export const useGetProjectNote = (id: string) => {
  return useQuery({
    queryKey: ["project-note", id],
    queryFn: () => getProjectNote(id),
    enabled: !!id,
  });
};

export const useCreateProjectNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateProjectNoteDto) => createProjectNote(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["project-notes"] });
    },
  });
};

export const useUpdateProjectNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateProjectNoteDto }) =>
      updateProjectNote(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["project-notes"] });
    },
  });
};

export const useToggleProjectNotePin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => toggleProjectNotePin(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["project-notes"] });
    },
  });
};

export const useDeleteProjectNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteProjectNote(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["project-notes"] });
    },
  });
};
